import Vue from 'vue'
import axios from 'axios'
import qs from 'qs'
// 创建 axios 实例
//const serviceName = 'http://localhost:8888'
//const serviceName = 'http://101.227.234.185:8000'
//const serviceName = 'http://218.78.104.7:8000'
const serviceName = 'https://www.shendi.com.cn'
const baseURL = serviceName+'/api' // api base_url
const baseURLocal = 'http://localhost:8888/api' // api base_url
const service = axios.create({
    baseURL: baseURL,
    timeout: 45000 // 请求超时时间,
})
const err = (error) => {
    if (error.response) {
        const data = error.response.data
        if (error.response.status === 401) {

        } else if (error.response.status === 403) {

        } else if (error.response.status === 502) {

        } else if (error.response.status === 429) {

        } else {

        }
    }
    return Promise.reject(error)
}

// request interceptor
service.interceptors.request.use(config => {
    if (window.location.host.indexOf('192.168') > -1 || window.location.host.indexOf('localhost') > -1) {
        //判断是内网地址的话，就请求内网后端接口地址
        config.baseURL = baseURLocal
    } else {
        //判断是外网地址的话，就请求外网后端接口地址
        config.baseURL = baseURL
    }
    if (config.method === 'post') {
        if (config.data.params) {
            config.data.params = JSON.stringify(config.data.params)
        }
    }
    config.method === 'get' ? config.params = {...config.params} : config.data = qs.stringify({...config.data})
    config.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'

    return config
}, err)

// response interceptor
service.interceptors.response.use((response) => {
    if (response.data.code === httpClient.HTTP_OK_STATUS) {
        // 服务端定义的响应code码为0时请求成功
        // 使用Promise.resolve 正常响应
        return Promise.resolve(response.data)
    } else {
        return Promise.reject(response.data)
    }
}, err)

const httpClient = {
    //网络请求成功状态值
    HTTP_OK_STATUS: 100,
    /**
     * get请求
     */
    get(me, option) {
        let params = option.data ? option.data : {}
        let config = {params, ...option}
        return service.get(option.url, config).then(res => {
            if (res.code === this.HTTP_OK_STATUS) {
                option.success && option.success(me, res.data, res.extra)
            } else {
                option.fail && option.fail(me, res.data)
            }
        }).catch(function (err) {
            option.error && option.error(me, err)
        })
    },
        /**
         * get请求
         */
        getSync( option) {
            let params = option.data ? option.data : {}
            let config = {params, ...option}
            return service.get(option.url, config)
        },


    /**
     * post请求
     */
    post(me, option) {
        let params = option.data ? option.data : {}
        if(option.venueId){
            let userInfo = Vue.ls.get('bowling_userInfo')
            params.venueId = JSON.parse(userInfo).venueId
        }
        return service.post(option.url, params).then(res => {
            if (res.code === this.HTTP_OK_STATUS) {
                option.success && option.success(me, res.data, res.extra)
                if (res.message) {
                    me.$message.destroy()
                    me.$message.success(res.message)
                }
                // me.$forceUpdate();
            } else {
                option.fail && option.fail(me, res.data)
            }
        }).catch(function (err) {
            option.error && option.error(me, err.response)
        })
    },


}
export {
    service as axios,
    serviceName,
    httpClient
}
